import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";
import { helpers } from "../../common/lib";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.ASSIGNMENT_DETAILS_GET_REQUEST: {
            return getInitialState.list();
        }
        case actionTypes.ASSIGNMENT_DETAILS_GET_SUCCESS: {
            const { assignmentDetails } = action.payload;
            return helpers.getListReducer(state, assignmentDetails);
        }
        case actionTypes.ASSIGNMENT_DETAILS_MERGE_SUCCESS: {
            const { assignmentDetails } = action.payload;
            return helpers.updateListReducer(state, assignmentDetails);
        }
        default: {
            return state;
        }
    }
}
